"use strict";

var _require = require("./serialization"),
    produceXMLSerialization = _require.produceXMLSerialization;

var XMLSerializer = require("./XMLSerializer");

module.exports = {
  XMLSerializer: XMLSerializer,
  produceXMLSerialization: produceXMLSerialization
};